<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">常见问题及说明</span>
            </template>
            <template #left>
                <router-link to="/">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/"><van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/></router-link>
            </template>
        </van-nav-bar>


        <van-collapse v-model="activeNames">
            <van-collapse-item title="有没有比较好的学习方法" name="1">
                练习方法：读题学习→所有题→点击下方“读题模式”顺序把所有考题熟悉并记住答案→顺序练习→最后再模拟考试，不建议只进行模拟考试而不系统的学习所有考题。
            </van-collapse-item>
            <van-collapse-item title="是否需要注册" name="2">
                不需要，当您关注本公众号进入系统后，系统会在后台自动为您建立学习帐户，即使您取消关注后这个帐户仍然在一定时间内有效（3个月以内）。
            </van-collapse-item>
            <van-collapse-item title="充值后能在电脑上使用吗" name="3">
                可以在电脑上使用, 只需要在电脑上安装一个微信电脑版即可。
            </van-collapse-item>
            <van-collapse-item title="充值后有什么特权" name="4">
                充值后是针对当前科目有效的，充值后，在有效期内您可以无限次的使用所有功能，学习充值科目的所有试题。
            </van-collapse-item>
            <van-collapse-item title="如何充值" name="5">
                充值后是针对当前科目有效的，充值后，在有效期内您可以无限次的使用所有功能，学习充值科目的所有试题。
            </van-collapse-item>
            <van-collapse-item title="充值后可以更改省份吗" name="6">
                进入系统后，点击 “科目充值” 进入充值画面， 选择相应的套餐完成充值即可，充值是针对当前科目有效的，比如：您充值了低压电工， 此次充值仅对低压电工这个科目有效，选择其它科目，仍然会显示 “未充值”
            </van-collapse-item>
            <van-collapse-item title="可以充值多个科目吗" name="7">
                可以的, 您只需要在主界面上选择要充值的科目, 再点科目充值进行充值即可, 也可以在科目充值的画面上选择要充值的科目。
            </van-collapse-item>
            <van-collapse-item title="我已经付款, 但显示未充值, 怎么回事" name="8">
                在极少数情况下, 由于网络故障导致系统没有收到微信服务器的通知, 会认为您未付款, 你可以退出系统, 等一会儿再进。
                充值以后，如果您更改到了其它科目上, 则会显示未充值。 还有一种情况就是您的充值已经过期了，也会显示未充值。
                如果您是用的代充, 请点击个人中心->我的充值号查看, 并用抄下充值号, 然后回到主界面，点击 “绑定充值号”。
                如果仍不行, 请在公众号内留言并且务必带上您的支付单号或者商户单号, 客服将给您人工确认。
            </van-collapse-item>
            <van-collapse-item title="我的微信不能支付，如何充值科目" name="9">
                您可以使用充值功能请其它人帮您付款，具体流程如下：
                1、 请其它人关注我们的公众号，如果已经关注了，则请进入系统。
                2、 付款人在系统主界面上点击 “科目充值”， 在里面点击 “代充值”，选择相应的套餐并付款，系统会返回一个充值号。
                3、 在您的手机上， 进入系统主界面，点击 “绑定充值号”，输入这个充值号，点击 “绑定” 即可。
            </van-collapse-item>
            <van-collapse-item title="如何切换科目" name="10">
                直接在主画面上点击 “当前科目” 右边的 “更改”，系统将调出科目选择器，您就可以切换到其它科目了。
            </van-collapse-item>
            <van-collapse-item title="进入练习或者模拟后, 没题怎么办" name="11">
                请点击 “个人中心”， “清除缓存” 复位一下系统, 如果仍不行, 请及时同我们联系。
            </van-collapse-item>
            <van-collapse-item title="多少分及格" name="12">
                一般都是80分及格。
            </van-collapse-item>
            <van-collapse-item title="为什么不能保存错题" name="14">
                错题是在练习或者模拟考试结束后才会保存的，请在结束练习后，务必点击左上角的 “返回” 退出，这样才能保存。
            </van-collapse-item>
            <van-collapse-item title="发现系统数据有些混乱, 如何处理" name="15">
                请点击 “个人中心”， “清除缓存” 复位一下系统, 如果仍不行, 请及时同我们联系。
            </van-collapse-item>
            <van-collapse-item title="进不了系统" name="16">
                如果画面显示 “网络故障” 则请检查您的手机是否打开了数据， 或者WIFI连接是否已经断开。
                如果您的网络连接是正常的，则可能是您当地的网络服务到我们网站服务器的路由出了问题，可以稍等几小时再试，如果这些都没问题，则有极可能是我们的网站服务器由于某种未知的原因停止了服务（黑客攻击，机房断电等等），请及时同我们联系。
            </van-collapse-item>

            <van-collapse-item title="网络没问题，但进入系统显示混乱或者错误，怎么办" name="17">
                这种情况一般是您手机缓存数据出现错误导致的, 请在公众号菜单最右边 “更多” 上选择 “清除缓存” ，然后再试。
            </van-collapse-item>
            <van-collapse-item title="练习或是模拟的时候字体太小" name="18">
                在练习或者模拟考试的画面上， 请点击右上角 “字+” ，系统将让您选择合适的字体显示大小。
            </van-collapse-item>
            <van-collapse-item title="联系客服" name="19">
                您可以直接在微信公众号内留言，我们的客服为尽快为您解答。您也可以通过QQ: 直接和我们实时联系。
            </van-collapse-item>
            <van-collapse-item title="简介" name="20">
                本公众号致力于提供安全生产资格、特种作业人员资格、煤矿类作业人员及建筑类从业人员资格考试的权威试题学习练习和模拟考试。减少相关科目考试的备考难度， 提升学习和复习效率，
                助力学员快速通过考试，达到顺利取证的目的。
            </van-collapse-item>
        </van-collapse>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeNames: []
            };
        }
    }
</script>
